<div class="bg-m0 flex flex-col p-9">
  <div
    data-cy="createProjectDialogTitle"
    class="text-s2 mt-5 select-none text-left text-2xl font-semibold"
    >Create Project</div
  >

  <div class="text-s2 mt-9 select-none text-left text-base font-semibold"
    >Project Name</div
  >

  <form
    class="flex flex-col"
    [formGroup]="createProjectForm"
    (ngSubmit)="create()"
  >
    <input
      autocomplete="off"
      spellcheck="false"
      data-cy="createProjectDialogProjectNameInput"
      class="form-input border-s3 focus:border-m600 mt-2 select-none rounded"
      [ngClass]="{
        'border-r600':
          createProjectForm.controls['projectName'].invalid &&
          createProjectForm.controls['projectName'].touched
      }"
      formControlName="projectName"
      placeholder=""
    />
    <m-validation
      [control]="createProjectForm.controls['projectName']"
    ></m-validation>

    <div class="text-s2 mt-5 select-none text-left text-base font-semibold"
      >Git URL of Remote Repository (GitHub, GitLab, BitBucket, etc)</div
    >

    <!-- <div
      data-cy="createProjectDialogManagedCheckbox"
      class="mt-5 flex h-9 cursor-pointer flex-row items-center"
      (click)="managedOnClick()"
    >
      <div
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600': projectRemoteRepoType === projectRemoteRepoTypeEnum.Managed
        }"
      >
        <m-check-icon
          *ngIf="projectRemoteRepoType === projectRemoteRepoTypeEnum.Managed"
        ></m-check-icon>
      </div>

      <div class="ml-5 select-none text-base">Managed (server directory)</div>
    </div> -->

    <!-- <div
      data-cy="createProjectDialogGitCloneCheckbox"
      class="mt-5 flex h-9 cursor-pointer flex-row items-center"
      (click)="gitCloneOnClick()"
    >
      <div
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600':
            projectRemoteRepoType === projectRemoteRepoTypeEnum.GitClone
        }"
      >
        <m-check-icon
          *ngIf="projectRemoteRepoType === projectRemoteRepoTypeEnum.GitClone"
        ></m-check-icon>
      </div>

      <div class="ml-5 select-none text-base"
        >git Clone (GitHub, GitLab, BitBucket, etc) - recommended</div
      >
    </div> -->

    <div
      *ngIf="projectRemoteRepoType === projectRemoteRepoTypeEnum.GitClone"
      class="flex w-full flex-col"
    >
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="createProjectDialogGitUrlInput"
        class="form-input border-s3 focus:border-m600 mt-3 w-full select-none rounded"
        [ngClass]="{
          'border-r600':
            createProjectForm.controls['projectGitUrl'].invalid &&
            createProjectForm.controls['projectGitUrl'].touched
        }"
        formControlName="projectGitUrl"
        placeholder="SSH git URL (git@github.com:ACCOUNT/REPOSITORY.git)"
      />
      <m-validation
        [control]="createProjectForm.controls['projectGitUrl']"
      ></m-validation>

      <div class="text mt-5 select-none text-left"
        >Add this <span class="text-s2 font-semibold">Deploy Key</span> to your
        git provider and enable
        <span class="text-s2 font-semibold">Write Access</span>
      </div>
      <div class="text select-none text-left"
        >(for github.com use Github Repository Settings Page)</div
      >

      <div class="relative mt-5 h-[300px] w-full">
        <div
          *ngIf="publicKey"
          class="text-g700 text-base"
          style="word-break: break-all"
          >{{ showPublicKey ? publicKey : maskedPublicKey }}</div
        >
        <ngx-spinner
          [ngClass]="{
            invisible: !!publicKey
          }"
          class="invisible"
          [name]="spinnerName"
          color="#0084d1"
          bdColor="#00000000"
          size="default"
          type="ball-clip-rotate"
          [fullScreen]="false"
          [disableAnimation]="true"
          [zIndex]="10"
        >
        </ngx-spinner>
      </div>

      <div
        data-cy="createProjectDialogGitCloneCheckbox"
        class="mt-5 flex h-9 cursor-pointer flex-row items-center"
        (click)="isDeployKeyAddedOnClick($event)"
      >
        <div
          data-cy="createProjectDialogDeployKeyAddedCheckbox"
          class="border-m600 text-m0 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded border-2 focus:outline-none"
          [ngClass]="{
            'bg-m600': isDeployKeyAdded === true
          }"
        >
          <m-check-icon *ngIf="isDeployKeyAdded === true"></m-check-icon>
        </div>

        <div class="ml-5 select-none flex-col text-base">
          <div>Remote Repository has at least 1 commit</div>
        </div>
      </div>
    </div>

    <div class="mt-8 flex flex-row items-center">
      <button
        data-cy="createProjectDialogCreateButton"
        class="bg-m600 text-m0 w-28 select-none rounded py-3 font-medium focus:outline-none"
        type="submit"
        [ngClass]="{
          'bg-m600':
            projectRemoteRepoType === projectRemoteRepoTypeEnum.Managed ||
            isDeployKeyAdded === true,
          'bg-s400 cursor-default':
            projectRemoteRepoType === projectRemoteRepoTypeEnum.GitClone &&
            isDeployKeyAdded === false
        }"
        [disabled]="
          projectRemoteRepoType === projectRemoteRepoTypeEnum.GitClone &&
          isDeployKeyAdded === false
        "
        >Create</button
      >

      <button
        data-cy="createProjectDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 select-none rounded border py-3 font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >

      <div *ngIf="copied" class="text-s1 ml-auto text-lg">Copied!</div>

      <button
        *ngIf="publicKey"
        class="border-s400 text-s500 select-none rounded border px-5 py-3 text-base font-medium focus:outline-none"
        [ngClass]="{ 'ml-auto': !copied, 'ml-3': copied }"
        type="button"
        (click)="copyToClipboard()"
      >
        Copy to Clipboard
      </button>

      <button
        *ngIf="publicKey"
        class="border-s400 text-s500 ml-3 w-[140px] select-none rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="togglePublicKey()"
      >
        {{ showPublicKey ? 'Hide Value' : 'Show Value' }}
      </button>
    </div>
  </form>
</div>
